<template>
  <li @click="onClick">
    <div class="question">
      <div>
        <span>{{ question }}</span>
      </div>

      <div class="icon">
        <zg-icon
          icon="chevron"
          size="small"
          :rotate="expanded ? '180' : '0'"
        />
      </div>
    </div>

    <div
      v-if="expanded"
      class="answer"
      v-html="answer"
    />
  </li>
</template>

<script>
  import ZgIcon from '../ZgIcon/ZgIcon.vue'

  export default {
    name: 'ZgFaqListItem',
    components: {
      ZgIcon
    },
    props: {
      question: {
        type: String,
        required: true
      },
      answer: {
        type: String,
        required: true
      }
    },
    data: () => ({
      expanded: false,
      focused: false
    }),
    methods: {
      onClick () {
        this.focused = false
        this.expanded = !this.expanded
      }
    }
  }
</script>

<style scoped lang="scss">
  li {
    list-style: none;
    border-bottom: 1px solid color(gray-200);
  }

  .question {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: rhythm(small);
    cursor: pointer;
    transition: all 0.3s ease;

    span {
      @include type-title-s;

      margin: 0;
    }

    .icon {
      display: flex;
      justify-content: center;
      align-self: center;
      transition: all 0.3s ease;
    }

    &:hover,
    &:hover svg {
      color: color(brand-500)
    }
  }

  .answer {
    padding: 0 rhythm(small) rhythm();
  }

  li {
    &:focus {
      box-shadow: box-shadow(focus);
      outline: none;
    }

    &:focus:not(:focus-visible) {
      box-shadow: none;
    }
  }
</style>
